module.exports = __webpack_public_path__ + "img/product-preview-87.135570c.png";